import React, {useState} from 'react';

import {Container, Content} from './styles';
import {hideAllError, showError} from "../../services/serviceShowMessage";
import InputText from "../../components/InputText";
import ButtonConfirm from "../../components/ButtonConfirm";
import ButtonBack from "../../components/ButtonBack";
import {passwordReset} from "../../services/servicePasswordReset";
import {decode as base64Decode} from "base-64";

interface Props {
    show: boolean
}

const PasswordReset: React.FC<Props> = (props) => {

    const urlBase = process.env.REACT_APP_URL_BASE ? process.env.REACT_APP_URL_BASE : '';

    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const [data, setData] = useState({
        password: '',
        rePassword: '',
    });

    const openHome = () => {
        window.location.href = '/' + localStorage.getItem('@Unisuam/uriRedirect');
        return null;
    };

    const open = () => {

        try {

            let uriRedirect = '';
            let url = localStorage.getItem('@Unisuam/uriRedirect');

            if (typeof url === "string") {
                uriRedirect = base64Decode(url);
            }

            window.location.href = uriRedirect;

        } catch (e) {

            window.location.href = '';
        }

        return null;
    };

    const onPasswordReset = async (token: string, hash: string) => {
        setLoading(true);

        await passwordReset(urlBase, token, hash, data.password, data.rePassword).then(items => {
            if (!items.success) {
                showError(items.error);
            } else {
                hideAllError();

                setShowSuccess(true);
            }

            setLoading(false);

        }).catch(() => {
            setLoading(false);
        });

    };

    const handleChange = (event: { target: { value: any; name: any; }; }) => {
        const value = event.target.value;
        setData({
            ...data,
            [event.target.name]: value
        });
    };

    const onSubmitSendPassword = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        confirmSendPassword().then(() => {
        });
    };

    const confirmSendPassword = async () => {
        let token = localStorage.getItem('@Unisuam/token');
        let hash = localStorage.getItem('@Unisuam/hash');

        if (typeof token === "string" && typeof hash === "string") {
            await onPasswordReset(token, hash);
        }
    };

    return (
        <Container>
            <Content show={props.show && !showSuccess}>
                <h5>Crie uma senha nova</h5>
                <Container>
                    <li>No mínimo 8 caractéres</li>
                    <li>Pelo menos um número</li>
                    <li>Pelo menos uma letra maiúscula</li>
                    <li> Pelo menos uma letra minúscula</li>
                    <li>Pelo menos um símbolo</li>
                </Container>
                <form onSubmit={onSubmitSendPassword}>
                    <label htmlFor={'formSenha'}>Senha nova*:</label>
                    <InputText placeholder={''}
                               onChange={handleChange}
                               type={'password'}
                               autoComplete={'false'}
                               name={'password'}
                               id={'password'}
                               showDisabled={loading}
                    />
                    <label htmlFor={'formReSenha'}>Reinsira a senha nova*:</label>
                    <InputText placeholder={''}
                               onChange={handleChange}
                               type={'password'}
                               autoComplete={'false'}
                               name={'rePassword'}
                               id={'rePassword'}
                               showDisabled={loading}
                    />
                    <ButtonConfirm type={'submit'}
                                   onClick={() => confirmSendPassword()}
                                   label={'OK'}
                                   showLoading={loading}
                    />
                    <ButtonBack type={'button'}
                                onClick={() => openHome()}
                                label={'Voltar'}
                                disabled={loading}
                    />
                </form>
            </Content>

            <Content show={showSuccess}>
                <h5>Sua senha foi alterada com sucesso</h5>
                <br/>
                <ButtonConfirm type={'button'}
                               onClick={() => open()}
                               label={'Concluido'}
                />
            </Content>
        </Container>
    );
};

export default PasswordReset;
